function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.667 16H4M28 5.333v21.334M16 9.333l6.668 6.668L16 22.668",
  stroke: "currentColor",
  strokeWidth: 2.667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMenuCloseRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMenuCloseRight;